import { default as Image } from '@react/shared/components/Image';
import ReadMore from '@react/shared/components/ReadMore';
import Link from 'next/link';
import { AdvisorPreviewProps } from 'sly/hubPage/components/HubDynamicContent/DynamicAdvisors/AdvisorPreview/AdvisorPreview.types';
import StyledLink from 'sly/hubPage/components/HubDynamicContent/SharedComponents/StyledLink';
import { assetPath } from 'sly/lib/path';

function AdvisorPreviewBody({ item }: AdvisorPreviewProps) {
  return (
    <div
      className='flex h-full flex-col items-center py-l px-m md:mb-0 md:flex md:p-l'
      data-tp-id='gen-div-cf4282cf-a75c-4523-bffa-f9ea3fcb7e7c'
    >
      <div
        className='mx-auto mb-m h-[7.5rem] w-[7.5rem] overflow-hidden rounded-full md:ml-0 md:mr-l md:mb-0 md:h-20 md:w-20'
        data-tp-id='gen-div-86c128f4-f3b7-448e-b9f4-f3ccfa3971da'
      >
        <Image
          src={
            item.info.profileImageUrl ||
            assetPath('uploads/react-assets/img-placeholder.png')
          }
          layout='raw'
          width={200}
          height={200}
          className='h-full w-full object-cover'
          alt={item.name}
          data-tp-id='gen-Image-5a587768-8ef9-4a78-ae75-44302a7f1d98'
        />
      </div>
      <div
        className='text-slate-base'
        data-tp-id='gen-div-ff1fbe8c-1fd9-43f7-8872-63aa903d9062'
      >
        <div
          className='font-t-s mb-m text-center'
          data-tp-id='gen-div-0ed2be13-70a7-421b-a72a-035cd4bae4c9'
        >
          {`${item.info.displayName} - ${item.info.citiesServed?.[0]}`}
        </div>

        {item.info.bio && (
          <ReadMore clampClassName='line-clamp-3'>{item.info.bio}</ReadMore>
        )}
      </div>
    </div>
  );
}

export default function AdvisorPreview({ item }: AdvisorPreviewProps) {
  if (!item.info.url) {
    return (
      <div
        className='border-[1px] border-[#E7E8EA] hover:shadow-[0_0.25rem_1rem_0_rgb(0_0_0_/_10%)]'
        data-tp-id='gen-div-978346da-8b43-4a78-b67b-e5105d18328d'
      >
        <AdvisorPreviewBody item={item} />
      </div>
    );
  }
  return (
    <Link href={item.info.url} passHref legacyBehavior>
      <StyledLink>
        <AdvisorPreviewBody item={item} />
      </StyledLink>
    </Link>
  );
}
